// Estado del usuario (SharedUserRow.status) → label legible + variante del Badge. Fuente ÚNICA
// del mapeo, reutilizada por todas las tablas/menús de usuarios (tenant y platform). Antes vivía
// duplicada byte a byte en 5 archivos.
//
// NO existe "INACTIVE": el equivalente a inactivo es SUSPENDED (deshabilitado). ACTIVE = puede
// entrar normalmente. INVITED = creado, aún no activó su cuenta.
//
// Es el MISMO union tanto para el user del tenant (`TenantUserStatusLocal`) como para el admin
// platform (`PlatformUserStatusLocal`), por eso `UserStatus` es el tipo canónico compartido.
export type UserStatus =
    | 'INVITED'
    | 'ACTIVE'
    | 'SUSPENDED'
    | 'LOCKED'
    | 'OFFBOARDED'
    | 'DELETED';

export type UserStatusVariant = 'default' | 'secondary' | 'outline' | 'destructive';

export const USER_STATUS_META: Record<UserStatus, { label: string; variant: UserStatusVariant }> = {
    INVITED: { label: 'Invitado', variant: 'outline' },
    ACTIVE: { label: 'Activo', variant: 'default' },
    SUSPENDED: { label: 'Suspendido', variant: 'destructive' },
    LOCKED: { label: 'Bloqueado', variant: 'destructive' },
    OFFBOARDED: { label: 'Dado de baja', variant: 'secondary' },
    DELETED: { label: 'Eliminado', variant: 'secondary' },
};

// Opciones del filtro de estado (orden estable para el <select>). Mismo orden que tenían las copias.
export const USER_STATUS_OPTIONS = Object.keys(USER_STATUS_META) as UserStatus[];
